var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460.334 460.334",
    style: {
      enableBackground: "new 0 0 460.334 460.334"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71E2F0"
    },
    d: "M230.167,0c-127.026,0-230,102.975-230,230c0,115.438,85.045,211.014,195.9,227.489l264.01-234.015 C456.621,99.467,355.01,0,230.167,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38C6D9"
    },
    d: "M460.167,230.333c0-2.294-0.043-4.577-0.11-6.855L305.371,68.793L154.664,219.5l66.989,66.99 L99.358,361.143l96.664,96.664c11.142,1.658,22.542,2.527,34.145,2.527C357.192,460.333,460.167,357.359,460.167,230.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#366796"
    },
    d: "M230.018,37.582c58.857,0,106.565,47.708,106.565,106.565s-47.708,106.565-106.565,106.565 l-37.391-106.565L230.018,37.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5488A8"
    },
    d: "M230.018,37.582v213.13c-58.857,0-106.565-47.708-106.565-106.565S171.161,37.582,230.018,37.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M323.867,270.712c25.55,12.621,48.169,30.303,66.584,51.721C358.473,377.765,298.67,415,230.167,415 l-20-92.144l95.785-52.145L323.867,270.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#366796"
    },
    d: "M136.467,270.712c-25.55,12.621-48.169,30.303-66.584,51.721 C101.86,377.765,161.664,415,230.167,415V308.212l-75.785-37.501L136.467,270.712z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#366796"
    },
    points: "277.667,270.712 220.167,308.212 230.167,346.496 305.951,270.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5488A8"
    },
    points: "182.667,270.712 230.167,308.212 230.167,346.496 154.382,270.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "230.167,270.712 220.167,291.003 230.167,318.212 277.667,270.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "182.667,270.712 230.167,318.212 230.167,270.712  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d46770fb6e8c396ca85c079b63178567.svg";
export { ForwardRef as ReactComponent };